<template>
    <div>
        <HeaderTopComponent v-if="!menuMovil"/>
        <MenuComponent v-if="!menuMovil"/>
        <MenuMovilComponent v-if="menuMovil" class='px-6 px-sm-10'/>
        <v-col
            class="mt-165 px-0 py-0 slide"
            cols="12" 
        >
            <v-carousel 
                v-model="model"
                show-arrows-on-hover
                cycle
                interval="5000"
            >
                <v-carousel-item
                    v-for="(img, i) in imgsCarousel"
                    :key="i"
                >
                    <v-sheet>
                        <v-img :src="require('@/assets/'+img)" ></v-img>
                    </v-sheet>
                </v-carousel-item>
            </v-carousel>
        </v-col>      
        <div class='mx-5 mx-sm-10 mx-md-16 px-md-16  text-md-left' id='ofertas'>
            <v-row v-if="$vuetify.breakpoint.width > 640">
                <v-col cols="12" md="4" sm=6>
                    <v-card
                        elevation="0"
                        class='card-middle-section'
                        :style=styleCardMiddleSection
                        tile
                    >
                        <v-row
                            align="center"
                            justify="center"
                            class='card-text-custom py-0 px-0'
                        >
                            <v-col cols="3" md=4  class='text-center py-0'>
                                <img :src="`${require('@/assets/icono-1.png')}`" class="width-img" >
                            </v-col>
                                <v-col cols="9" md=8  class='text-left font-title'>
                                    <h4>COMPRE  <br class="d-none d-md-block "/> DESDE SU CASA</h4>
                                </v-col>
                        </v-row>
                    </v-card>
                </v-col>
                <v-col cols="12" md="4" sm=6>
                    <v-card
                        elevation="0"
                        class='card-middle-section'
                        :style=styleCardMiddleSection
                        tile
                    >
                        <v-row
                            align="center"
                            justify="center"
                            class='card-text-custom py-0 px-0'
                        >
                            <v-col cols="3" md=4  class='text-center col-sm-4 py-0'>
                                <img :src="`${require('@/assets/icono-2.png')}`" class="width-img" >
                            </v-col>
                                <v-col cols="9" md=8 class='text-left font-title  col-sm-8'>
                                    <h4>DIFERENTES  <br class="d-none d-md-block "/> MÉTODOS DE PAGO</h4>
                                </v-col>
                        </v-row>
                    </v-card>
                </v-col>
                <v-col cols="12" md="4" sm=6>
                    <v-card
                        elevation="0"
                        class='card-middle-section'
                        tile
                    >
                        <v-row
                            align="center"
                            justify="center"
                            class='card-text-custom py-0 px-0'
                        >
                            <v-col cols="3" md=4 class='text-center col-sm-4 py-0'>
                                <img :src="`${require('@/assets/icono-4.png')}`" class="width-img">
                            </v-col>
                                <v-col cols="9" md=8 class='text-left font-title  col-sm-8'>
                                    <h4 >SERVICIOS  <br class="d-none d-md-block "/> A DOMICILIO</h4>
                                </v-col>
                        </v-row>
                    </v-card>
                </v-col>
                <!-- <v-col cols="12" md="3" sm=6>
                    <v-card
                        elevation="0"
                        class='card-middle-section'
                    >
                        <v-row
                            align="center" justify="center"
                            class='card-text-custom py-0  px-0'
                        >
                            <v-col cols="3" md=4 class='text-center col-sm-4 py-0'>
                                <img :src="`${require('@/assets/icono-3.png')}`" class="width-img" >
                            </v-col>
                            <v-col cols="9" md=8 class='text-left font-title  col-sm-8'>
                                <h4>PREGUNTAS <br class="d-none d-md-block "/> FECUENTES</h4>
                            </v-col>
                        </v-row>
                    </v-card>
                </v-col> -->
            </v-row>
            <v-row v-else>
                <v-col>
                    <v-text-field
                        v-model=productText
                        placeholder="Busque su medicina o producto aquí"
                        outlined
                        single-line
                        dense
                        rounded
                        append-icon="mdi-magnify"
                        background-color="white"
                        flat
                        hide-details
                        id="input-index-search"
                        @keydown.enter="redirectShoppingCar"
                        @click:append="redirectShoppingCar"
                    ></v-text-field>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" v-if="cantCarrousel">
                    <div class="text-md-h3 text-h4 font-weight-bold green2--text font-title text-center mb-10 my-md-16">
                        <i>OFERTAS ESPECIALES</i>
                    </div>    
                </v-col>
            </v-row>
            <v-flex v-if="cantCarrousel" style="height:300px">
                <template slot:default>
                    <v-carousel hide-delimiters>
                        <v-carousel-item v-for="i in cantCarrousel" :key="i" style="width: 90%;margin: 0 auto;">
                            <v-layout >
                                <v-flex sm=2 v-for="(p, j) in productsComplement[i-1]" :key="j" px-2>
                                    <v-card elevation="0" light v-if="p.product_name_web!=''">
                                        <img
                                            :src="!!p.medium_image_url ? (urlApi+pathFileProducts+p.medium_image_url) : ''"
                                            style="width: 100%;margin:0 auto;cursor:pointer"
                                            @click="redirectRelatedProduct(p.url_product)"
                                        >
                                        <div class='text-center'>
                                            <div class='grayblack--text font-title' style="height: 80px;" v-html=p.product_name_web> </div>
                                            <v-btn 
                                                rounded outlined 
                                                class='btn-quote-products font-title font-weight-black'
                                                @click="addOtherProducts(p)"
                                            > COTIZAR </v-btn>
                                        </div>
                                    </v-card>
                                    <v-card light elevation="0" v-else>
                                        <img :src="require('@/assets/blanco.png')" style="width:100%">
                                    </v-card>
                                </v-flex>
                            </v-layout>
                        </v-carousel-item>
                    </v-carousel>
                </template>
            </v-flex>
            <v-col cols="12">
                <div class="text-md-h3 text-h4 font-weight-bold orange--text font-title text-center mb-md-16">
                    <i>Nuestros servicios</i>
                </div>    
            </v-col>
            <v-row>
                <v-col cols=12 sm=6 class='col-inline' >
                    <v-card
                        elevation="5"
                        outlined
                        class='card-info'
                        to='/medicamentos-especialidad'
                    >
                        <v-row
                            align="center"
                            justify="center"
                            class='card-text-custom py-0 px-2 px-sm-0'
                        >
                            <v-col cols="3" class='text-center col-sm-2 col-md-4 p-5'>
                                <img src='/files/img/medicina-landing.png' class="width-img2" >
                            </v-col>
                            <v-col cols="9" class="font-title col-sm-10 col-md-8">
                                <h5><i>Medicina de <br class="d-none d-md-none "/> especialidad</i></h5>
                            </v-col>
                        </v-row>
                    </v-card>
                </v-col>
                <v-col cols=12 sm=6 class='col-inline' >
                    <v-card
                        elevation="5"
                        outlined
                        class='card-info'
                        to='/aplicaciones'
                    >
                        <v-row
                            align="center"
                            justify="center"
                            class='card-text-custom py-0 px-2 px-sm-0'
                        >
                            <v-col cols="3" class='text-center col-sm-2 col-md-4 p-5'>
                                <img :src="`${require('@/assets/Sedes-CDA.png')}`" class="width-img2" >
                            </v-col>
                            <v-col cols="9" class="font-title col-sm-10 col-md-8">
                                <h5><i>Aplicaciones</i></h5>
                            </v-col>
                        </v-row>
                    </v-card>
                </v-col>        
                <v-col cols=12 sm=6 class='col-inline' >
                    <v-card
                        elevation="5"
                        outlined
                        class='card-info'
                        to='/estudios-medicos'
                    >
                        <v-row
                            align="center"
                            justify="center"
                            class='card-text-custom py-0 px-2 px-sm-0'
                        >
                            <v-col cols="3" class='text-center col-sm-2 col-md-4 p-5'>
                                <img :src="`${require('@/assets/S-servicios-medicos.png')}`" class="width-img2" >
                            </v-col>
                            <v-col cols="9" class="font-title col-sm-10 col-md-8">
                                <h5><i>Estudios <br class="d-none d-md-block"/> médicos</i></h5>
                            </v-col>
                        </v-row>
                    </v-card>
                </v-col>        
                <v-col cols=12 sm=6 class='col-inline'>
                    <v-card
                        elevation="5"
                        outlined
                        class='card-info'
                        to='/enfermeria'
                    >
                        <v-row
                            align="center"
                            justify="center"
                            class='card-text-custom py-0 px-2 px-sm-0'
                        >
                            <v-col cols="3" class='text-center col-sm-2 col-md-4 p-5'>
                                <img :src="`${require('@/assets/S-enfermeria.png')}`" class="width-img2" >
                            </v-col>
                            <v-col cols="9" class="font-title col-sm-10 col-md-8">
                                <h5><i>Enfermería</i></h5>
                            </v-col>
                        </v-row>
                    </v-card>
                </v-col>        
                <v-col cols=12 sm=6 class='col-inline'>
                    <v-card
                        elevation="5"
                        outlined
                        class='card-info'
                        to='/empresas_pymes'
                    >
                        <v-row
                            align="center"
                            justify="center"
                            class='card-text-custom py-0 px-2 px-sm-0'
                        >
                            <v-col cols="3" class='text-center col-sm-2 col-md-4 p-5'>
                                <img :src="`${require('@/assets/empresas-landing.png')}`" class="width-img2" >
                            </v-col>
                            <v-col cols="9" class="font-title col-sm-10 col-md-8">
                                <h5><i>empresas y <br class="d-none d-md-block"/> pymes</i></h5>
                            </v-col>
                        </v-row>
                    </v-card>
                </v-col>   
            </v-row>
            <!-- <v-flex>
                <v-carousel hide-delimiters >
                    <v-carousel-item v-for="i in 2" :key="i" style="width: 90%;margin: 0 auto;">
                        <v-layout>
                            <v-flex sm=2 v-for="j in 6" :key="j" px-2>
                                <v-card elevation="0" light>
                                     <v-img
                                        :src="require('@/assets/ProductoSinImagen.jpg')"
                                        aspect-ratio="0.7"
                                    ></v-img>
                                    <div class='text-center'>
                                        <h3>
                                            Vitamina C <br/>
                                            600mg x 30 Comp.
                                        </h3>
                                        <v-btn 
                                            rounded 
                                            outlined 
                                            class='btn-quote font-title font-weight-black'
                                        >
                                        COTIZAR
                                        </v-btn>
                                    </div>
                                </v-card>
                            </v-flex>
                        </v-layout>
                    </v-carousel-item>
                </v-carousel>
            </v-flex> -->
            <v-row>
                <v-col cols="12">
                    <div class="text-md-h3 text-h4 font-weight-bold green2--text font-title  my-md-10">
                        <i>Productos basados en su última visita:</i>
                    </div>       
                </v-col>
            </v-row>
            <LastProductsVisitedComponent />
            <v-col>
                <v-img :src="require('@/assets/banner-2.png')"></v-img>
                <!-- <v-btn
                    to='/contactos'
                    outlined 
                    class='btn-quote font-title font-weight-black rounded-lg py-2 px-3 py-sm-5 px-sm-7 text-caption text-md-h6'
                >!Conózcanos!</v-btn>    -->                  
            </v-col>
        </div>
        <FooterComponent />
    </div>
</template>

<script>

import HeaderTopComponent from '../partials/HeaderTopComponent'
import MenuComponent from '../partials/MenuComponent'
import FooterComponent from '../partials/FooterComponent'
import MenuMovilComponent from '../partials/MenuMovilComponent'
import LastProductsVisitedComponent from '../partials/LastProductsVisitedComponent'
import {mapActions, mapMutations, mapState} from 'vuex'
import Vue from 'vue'

export default {
    name: 'IndexComponent',
    components:{
        HeaderTopComponent,
        MenuComponent,
        FooterComponent,
        MenuMovilComponent,
        LastProductsVisitedComponent
    },
    data:()=>({
        cant:1,
        model: 0,
        productText:'',
        offerProducts:[],
        productsComplement:[],
        cantCarrousel:0,
        imgsCarousel: [
            'banner-roche.png',
            'banner-web-1.jpg',
            'banner-web-2.jpg',
            'banner-web-3.jpg',
            'banner-web-4.jpg'
        ],
    }),
    computed:{
        
        ...mapState(['selectedProducts','urlApi','pathFileProducts','sweeAlertAddProduct']),

        menuMovil(){
            return this.$vuetify.breakpoint.name == 'sm' || this.$vuetify.breakpoint.name == 'xs'
        },

        styleCardMiddleSection(){
            return this.$vuetify.breakpoint.name == 'md' || this.$vuetify.breakpoint.name == 'lg' ? 'border-right:2px solid silver' : ''
        }

    },
    methods:{

        ...mapMutations(['setUrl','itemShoppingCar','setTotalQuantity','setSelectedProducts']),

		...mapActions(['requestApi','dataCarousel']),

        redirectShoppingCar(){
           
            if(this.productText!='' && this.productText != null)
                this.$router.push(`/medicamentos-especialidad/${this.productText}`)
           
        },

        redirectRelatedProduct(product_id){
            location.href = `/medicamentos-especialidad/producto/${product_id}`
        },

        addOtherProducts({product_id,product_name_web,medium_image_url}){
            
            this.setSelectedProducts({
                product_id: product_id,
                internal_name: product_name_web,
                quantity: 1,
                images: medium_image_url
            })

            this.setTotalQuantity(this.cant)
            this.itemShoppingCar(this.selectedProducts)

            this.cant=0 
            Vue.swal({...this.sweeAlertAddProduct});

        },

        getOfferProducts(){

            this.setUrl('busqueda-catalogo')
            this.requestApi({
				method: 'PUT',
				data :{}
			}).then(res =>{

                this.offerProducts = res.data._embedded.busqueda_catalogo
                console.log(res.data._embedded.busqueda_catalogo)
                this.dataCarousel({
                    selectProduct:res.data._embedded.busqueda_catalogo,
                    width: this.$vuetify.breakpoint.width
                }).then( res => {
                    console.log(res)
                    this.cantCarrousel = res.cantCarrousel
                    this.productsComplement = res.productsComplement
                })

			})
        },


    },
    created(){
        
        this.getOfferProducts()
    
    }
    
}
</script>

<style scope>

    .card-middle-section{
		font-weight: bold;
		font-size: 1.2rem;
		line-height: .9;
        color:#a0a5a2!important
	}

    .card-text-custom{
        padding: 30px 28px!important;
    }
    
    .v-carousel__controls {   
        background: rgb(255 255 255)!important;
    }

    .v-carousel__controls__item{
        color: black!important;
    }

    /* .img-corona-virus{
        background-image: url("../../../../assets/banner-covid.png");
        background-size: contain;
        -o-background-size: contain;
        -moz-background-size: contain;
        -webkit-background-size: contain;
        border-radius: 10px!important;
        height: 405px;
        @media (max-width: @iphone-screen) {
            background-attachment: scroll;
        }
    } */

    .mt-200{
        margin-top:150px
    }

    .width-img{
        width: 80px;
    }

    .width-img2{
        width: 60px;
    }


    .v-application .text-md-h3, .v-application .text-sm-6{
        font-family: Asap!important;
        line-height:1;
    }

    .green2--text{
        color: #58c496;
    }

    .btn-quote{
        background: #26aeea;
        color:white!important
    }

    .end-section{
        font-size: 1.2rem;
        color: #a0a5a2!important;
    }

    .img-sservicio-domicilio{
        width:180%;
        position: relative;
        right: 46px;
    }

    .btn-banner-coronavirus{
        position: absolute;
        top: 60%;
        text-align: right;
        right: 5%;
    }

    @media(min-width:1250px){
        .col-inline{
            flex-basis: 0;
            flex-grow: 1;
            max-width: 100%;
        }
    }

    @media (max-width:1495px) {
        div.slide div.v-carousel{
            height: 480px!important;
        }
    }

    @media (max-width:1480px) {
        div.slide div.v-carousel{
            height: 430px!important;
        }
    }

    @media (max-width:1400px) {
        .width-img{
            width: 65px;
        }

        .card-middle-section{
            font-size: 1rem;
        }

        .img-sservicio-domicilio{
            width: 200%;
        }
    }

    @media (max-width:1271px) {
        div.slide div.v-carousel{
            height: 400px!important;
        }

        .img-sservicio-domicilio{
            width: 280%;
        }
    }

    @media (max-width:1166px) {
        div.slide div.v-carousel{
            height: 350px!important;
        }

        .img-sservicio-domicilio{
            width: 310%;
        }
    }

    @media (max-width:996px) {
        div.slide div.v-carousel{
            height: 330px!important;
        }

        .img-sservicio-domicilio{
            width: 100%;
            right: 10px;
        }
    }

    @media (min-width:961px) {
        .mt-200{
            margin-top:200px
        }
    }

    @media (max-width:932px) {
        div.slide div.v-carousel{
            height: 290px!important;
        }
    }

    @media (max-width:800px) {
        div.slide div.v-carousel{
            height: 270px!important;
        }
    }

    @media (max-width:726px) {
        div.slide div.v-carousel{
            height: 250px!important;
        }
    }

     /* @media (max-width:11166px) {
        
    } */
    
    @media (max-width:731px) {
        .mt-200{
            margin-top:0px
        }
    }

    @media (max-width:650px) {
        .mt-200{
            margin-top:0px
        }

        .card-text-custom{
            padding: 0px 28px!important;
        }

        div.slide div.v-carousel{
            height: 240px!important;
        }

        .img-sservicio-domicilio{
            width: 150%;
            right: 10px;
        }

        .btn-banner-coronavirus{
            top: 50%;
        }

    }

    @media (max-width:630px) {
        div.slide div.v-carousel{
            height: 210px!important;
        }

        .img-sservicio-domicilio{
            width: 100%;
            right: 10px;
        }
    }

    @media (max-width:530px) {
        div.slide div.v-carousel{
            height: 180px!important;
        }
    }

    @media (max-width:430px) {
        div.slide div.v-carousel{
            height: 170px!important;
        }

        .img-sservicio-domicilio{
            width: 150%;
            right: 20px;
        }

        .btn-banner-coronavirus{
            top: 30%;
            right: 0%;
        }

    }

    @media (max-width:400px) {
        div.slide div.v-carousel{
            height: 150px!important;
        }
    }

    @media (max-width:415px) {
        .mt-200{
            margin-top:90px
        }
    }

    @media (max-width:380px) {
        .mt-200{
            margin-top:40px
        }

        div.slide div.v-carousel{
            height: 155px!important;
        }

        .img-sservicio-domicilio{
            width: 200%;
            right: 30px;
        }
    }

    @media (max-width:320px) {
        
        div.slide div.v-carousel{
            height: 145px!important;
        }
    }

    .v-carousel__controls{
        display: none;
    }

</style>